<template>
    <div
        :id="modalId"
        class="app-confirmation-modal"
        data-overlay-open="true"
        role="dialog"
        aria-modal="true"
        @click.self="cancelled"
    >
        <div class="app-confirmation-modal__backdrop" :style="{ zIndex: overlayZIndex }"/>
        <div
            ref="dialog"
            class="app-confirmation-modal__dialog"
            :style="{ zIndex: overlayZIndex + 1 }"
            tabindex="-1"
        >
            <div class="app-confirmation-modal__content">
                <div class="app-confirmation-modal__body d-flex flex-column justify-content-center modal-alert">
                    <div class="text-center">
                        <app-icon :class="'text-'+(modalClass ? modalClass : 'danger')" :name="icon ? icon : 'x-circle'"/>
                    </div>
                    <h5 class="text-center font-weight-bold mt-4">{{ title ? title : $t('are_you_sure') }}</h5>
                    <p v-if="subTitle" class="text-center font-size-90 m-0 p-0">{{ subTitle }}</p>
                    <p class="mb-primary text-center font-size-90 p-0">
                        {{ message ? message : $t('this_content_will_be_deleted_permanently') }}
                    </p>
                    <div class="text-center" :class="{'loading-opacity': preloader}">
                        <a href="#" class="btn btn-secondary mr-2" @click.prevent="cancelled">
                            {{ secondButtonName ? secondButtonName : $t('no') }}
                        </a>
                        <app-load-more
                            :preloader="preloader"
                            :label="firstButtonName ? firstButtonName : $t('yes')"
                            class-name="btn btn-danger shadow-none"
                            @submit="confirmed"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OverlayStack from "../../../../core/helpers/app/OverlayStack";

    export default {
        name: "DeleteModal",
        props: {
            modalId: {
                type: String,
                required: true
            },
            message: {
                type: String
            },
            firstButtonName: {
                type: String
            },
            secondButtonName: {
                type: String
            },
            preloader: {
                type: Boolean,
                default: false
            },
            title: String,
            subTitle: String,
            icon: String,
            modalClass: String
        },
        data() {
            return {
                overlayZIndex: 1050,
            };
        },
        mounted() {
            if (this.$el.parentNode !== document.body) {
                document.body.appendChild(this.$el);
            }

            this.overlayZIndex = OverlayStack.nextZIndex(this.modalId);
            OverlayStack.syncBodyState();

            this.keydownHandler = (event) => {
                if (event.key === 'Escape') {
                    this.cancelled();
                }
            };

            document.addEventListener('keydown', this.keydownHandler);

            this.$nextTick(() => {
                if (this.$refs.dialog) {
                    this.$refs.dialog.focus();
                }
            });
        },
        beforeDestroy() {
            if (this.keydownHandler) {
                document.removeEventListener('keydown', this.keydownHandler);
            }

            OverlayStack.syncBodyState();
        },
        methods: {
            /**
             * $emit for confirmed opration
             */
            confirmed() {
                this.$emit('confirmed', false);
            },
            /**
             * $emit for cancelled opration
             */
            cancelled() {
                this.closed();
            },
            closed(){
                this.$emit('cancelled', false);
            }
        }
    }
</script>
